var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.installation)?_c('div',{attrs:{"id":"integration-overview"}},[_c('h6',[_vm._v(_vm._s(_vm.$t('Installation type')))]),_c('table',[_c('tr',[_c('td',[_c('img',{attrs:{"src":_vm.installation.image,"width":"75"}})]),_c('td',{staticClass:"pl-3"},[_vm._v(_vm._s(_vm.installation.label))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }